import React from "react";
import DPHeadCellWithTooltip from "Components/DP/DPHeadCell/DPHeadCell";
import { Typography } from "@material-ui/core";

const ProcessedSubmissionHeadCell= () => {
  return <DPHeadCellWithTooltip
    label="Processed Submission"
    content={
      <Typography variant="body1">
        Payments with associated errors will not be sent. No fee will be charged for failed payments.
      </Typography>
    }
  />;
};

export default ProcessedSubmissionHeadCell;
